import './index.css';

const SUPPORT_EMAIL = 'colby@mp3juug.com';

// Small "need help" line for checkout / order / ticket screens.
export default function SupportLine({ children }) {
  return (
    <p className='support-line'>
      {children || 'Need help?'}{' '}
      <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>
    </p>
  );
}
